import React, { useState } from "react";
import GenericModal from "./GenericModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsonNoEstaVacio } from "../../helper/utils";
import { useManagePostRequest } from "../../hooks/useManagePostRequest/useManagePostRequest";

const ActionGenericModal = ({ toggleModal, refreshPage, title ="Eliminar", actionLabel = "eliminar", api, item="item",id = "", name, payload = {}, externalCallback = null }) => {
  
  const [isSending, setIsSending] = useState(false);
  const [managePost] = useManagePostRequest();

  const handleAction = async () => {
    setIsSending(true);
    try {
      if (jsonNoEstaVacio(payload) && !id){
        await managePost(api(), payload, successHandleCallback);
      } else {
        await managePost(api(id), {}, successHandleCallback);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSending(false);
    }
  };

  const successHandleCallback = async () => {
    await refreshPage();
    if(externalCallback) await externalCallback();
    toggleModal();
  }

  return (
    <GenericModal
      titulo={title}
      showModal={toggleModal}
      width={"600px"}
    >
      <div className="modal-body pt-0 pl-0">
        <div className="container-fluid">
          Se va a {actionLabel} el siguiente {item}:
          <ul>
            <li>
              <strong>{name}</strong>
            </li>
          </ul>
          ¿Está seguro de esta acción?
        </div>
      </div>
      <div className="modal-footer justify-content-end">
        <button 
          className="btn btn-outline-primary generic-button-ficha-outlined"
          disabled={isSending}
          onClick={() => {toggleModal()}}>
          Cancelar
        </button>
        <button 
          className="btn btn-primary generic-button-ficha mr-2" 
          disabled={isSending}
          onClick={handleAction}>
          {title} {isSending && (<FontAwesomeIcon icon='spinner' transform="left-9" className="spinner ml-3"/>)}
        </button>
      </div>
    </GenericModal>
  );
};

export default ActionGenericModal;